import { AdvisorBubble, Column, FormUnit } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import { useFormItem, useNextLoading, useOnNextClick } from '@/providers'
import { Alert } from '@surein/ui'
import { TriangleAlert } from 'lucide-react'
import { Trans, useTranslation } from 'react-i18next'
import { useSaveAssessmentStep, useStepperWarning } from '../helpers'
import { StepperTestimonial } from './StepperTestimonial'
import React from 'react'

interface ApproxLaborCostStepProps {
  helperText?: string
}

export const ApproxLaborCostStep: React.FC<ApproxLaborCostStepProps> = ({
  helperText,
}) => {
  const { save, isLoading } = useSaveAssessmentStep(
    AssessmentStepKeys.approxLaborCosts,
  )

  const { t } = useTranslation()

  const { value } = useFormItem('approxPersonelExpenses')

  const { shouldShowWarning } = useStepperWarning(value)

  useOnNextClick(save)

  useNextLoading(() => isLoading, [isLoading])

  return (
    <Column gap="24px">
      <FormUnit
        helperText={helperText}
        name="approxPersonelExpenses"
        placeholder={t('currencyInputPlaceholder')}
        unit="€"
      />
      {shouldShowWarning && (
        <Alert
          icon={TriangleAlert}
          // @ts-expect-error change type in surein alert component
          text={<Trans i18nKey="approxLaborCostsWarning" />}
          variant="warning"
        />
      )}
      <AdvisorBubble text={t('approxLaborCostsAdvisorHint')} />
    </Column>
  )
}

export const ApproxLaborCostStepTestimonial: React.FC = () => (
  <StepperTestimonial
    stepKey="approxLaborCosts"
    imageSrc="katharina-headshot"
  />
)
